export default (element) =>
	new Promise((resolve) => {
		const observer = new MutationObserver(() => {
			if (element.offsetParent) {
				resolve();
			}
		});
		observer.observe(element, { attributes: true, childList: true });
	});
